module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00468.3ef4a013.jpg";